import React from 'react';
import InternalBar from '../TopLayout/InternalBar/InternalBar';
import './tasksInt.css';
import {
    bundling_learn_how,
    revenue_learn_how,
    trial_live_class_learn_how,
    notification_learn_how,
    coupon_code_learn_how,
    app_download_learn_how,
} from '../../../../cosmosTracking/cosmosEvents';


function TaskCardCompletedInt(props) {
    const { data} = props;
    const events = {
        14: bundling_learn_how,
        3: revenue_learn_how,
        9: trial_live_class_learn_how,
        5: notification_learn_how,
        2: coupon_code_learn_how,
        4: app_download_learn_how
    }

    // sorted task data
    const taskDataArr = data || [];
    const sortedTaskDataArr = [
        ...taskDataArr.filter(item => item?.isComplete)
    ];
    return (
        sortedTaskDataArr?.length > 0 && (
            <>
                <div className="task-page-completed">
                    <h2>Completed Tasks</h2>
                    {sortedTaskDataArr.map((item, index) => (
                        <div className="task-completed" key={index}>
                            <h4>{item?.task}</h4>
                            <div className="card-progressbar">
                                <InternalBar width={item?.percentage} />
                                <div className="card-completed-text">
                                    {item?.statType === 3 ? (
                                        item?.completedText
                                    ) : (
                                        <>
                                            {item?.total || 0} {item?.completedText}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>
        )
    );

}

export default TaskCardCompletedInt;
